import { Tooltip, tooltipClasses, styled } from '@mui/material';

// A reusable, app-wide tooltip with consistent styling
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip arrow enterDelay={300} classes={{ popper: className }} {...props} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey[800],
    color: '#fff',
    fontSize: 12,
    borderRadius: 4,
    boxShadow: theme.shadows[1],
  },
}));

export default CustomTooltip;
